import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { IFormFields } from '../type';
import { loginSaga } from './saga';
import { LoginState } from './types';

export const initialState: LoginState = {
  submit: false,
  error: null,
};

const slice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    login(state, action: PayloadAction<IFormFields>) {},
    setLoginSuccess(state, action: PayloadAction<boolean>) {
      state.submit = action.payload;
    },
    setLoginError(
      state,
      action: PayloadAction<{ error: string; errorDescription: string } | null>,
    ) {
      state.error = action.payload;
    },
  },
});

export const { actions: loginActions } = slice;

export const useLoginSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: loginSaga });
  return { actions: slice.actions };
};
